import { useContext, useEffect, useState } from "react";
import { MapComponent } from "./components/Maps";
import { OrderContext } from "../../../context/OrderContext";
import { maskCurrency, numOrderFormat } from "../../../utils/utils";
import { useCompany } from "../../../hooks/useCompany";
import { loadGMaps } from "../../../utils/loadMaps";
import { FiCheck, FiMapPin, FiNavigation, FiPackage, FiTrash2 } from "react-icons/fi";
import "../../../pages/admin.css";
import "./style.css";

export function RouteMaps() {
  const { orders = [] } = useContext(OrderContext)
  const [selecteds, setSelecteds] = useState([])
  const [loadMapCompleted, setLoadMapCompleted] = useState(false)

  const { configurations } = useCompany()
  const availableOrders = orders.filter((order) => Boolean(order?.deliveryDistrict?.location))

  useEffect(() => {
    if (configurations.id) {
      loadGMaps(() => {
        setLoadMapCompleted(!loadMapCompleted)
      }, configurations.googleKey)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configurations.googleKey, configurations.id])

  return (
    <div className="modal fade admin-form-modal route-planner-modal" id="modalRoutesMaps" tabIndex="-1" aria-labelledby="modalRoutesMapsLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <div className="route-planner-heading"><span><FiNavigation /></span><div><h5 className="modal-title" id="modalRoutesMapsLabel">Planejar rota de entregas</h5><p>Selecione os pedidos para montar o melhor trajeto</p></div></div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="route-planner-grid">
              <aside className="route-order-panel">
                <div className="route-panel-heading"><div><strong>Pedidos disponíveis</strong><span>{availableOrders.length} entregas com localização</span></div>{selecteds.length > 0 && <button type="button" onClick={() => setSelecteds([])}><FiTrash2 /> Limpar</button>}</div>
                  <div className="route-order-list">
                    {availableOrders.map((item) => {
                      const exists = selecteds.find(e => e.id === item.id)
                      return (
                        <button
                          type="button"
                          className={`route-order-item ${exists ? 'selected' : ''}`}
                          onClick={() => {
                            if (exists) {
                              return setSelecteds(selecteds.filter(e => e.id !== item.id))
                            }
                            setSelecteds([...selecteds, item])
                          }}
                          key={item.id}
                        >
                          <span className="route-order-check">{exists ? <FiCheck /> : <FiPackage />}</span>
                          <div className="route-order-copy"><div><strong>{numOrderFormat(item?.numOrder)}</strong><b>{maskCurrency(item.total)}</b></div><p>{item.name || 'Cliente não informado'}</p><small><FiMapPin /> {item.address ? `${item.address}${item.number ? `, ${item.number}` : ''}` : 'Localização cadastrada'} · {item?.motoboy?.name ?? "Sem entregador"}</small></div>
                        </button>
                      )
                    })}

                    {availableOrders.length === 0 && <div className="route-orders-empty"><FiPackage /><strong>Nenhum pedido disponível</strong><span>Os pedidos precisam ter uma localização válida.</span></div>}
                  </div>
              </aside>
              <section className="route-map-panel">
                <div className="route-panel-heading"><div><strong>Trajeto otimizado</strong><span>{selecteds.length} {selecteds.length === 1 ? 'parada selecionada' : 'paradas selecionadas'}</span></div><FiNavigation /></div>
                {loadMapCompleted ? <MapComponent dataDestinations={selecteds.map(order => ({ lat: order.deliveryDistrict.location.latitude, lng: order.deliveryDistrict.location.longitude, numOrder: order?.numOrder }))} /> : <div className="route-map-loading"><div className="spinner-border" role="status"><span className="visually-hidden">Carregando mapa...</span></div><span>Carregando mapa...</span></div>}
              </section>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}
